import { render } from "./AdministrarCompras.vue?vue&type=template&id=3d145d6d&scoped=true"
import script from "./AdministrarCompras.vue?vue&type=script&lang=js"
export * from "./AdministrarCompras.vue?vue&type=script&lang=js"

import "./AdministrarCompras.vue?vue&type=style&index=0&id=3d145d6d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d145d6d"]])

export default __exports__